"use client";
import { create } from "zustand";
import {
  devtools,
  DevtoolsOptions,
  subscribeWithSelector,
} from "zustand/middleware";
import { ScrollChatStore, ScrollChatStoreCreator } from "./types";

const createScrollChatStore: ScrollChatStoreCreator = (set, get) => {
  const initState = {
    bottomReached: false,
  };
  const setBottomReached = (status: boolean) => {
    set(() => ({
      bottomReached: status,
    }));
  };
  return {
    ...initState,
    setBottomReached,
  };
};

export const useChatScrollStore = create<ScrollChatStore>()(
  devtools(subscribeWithSelector(createScrollChatStore), {
    name: "ScrollChatStore",
    enabled: true,
    serialize: true,
  } as DevtoolsOptions),
);
